import { useRef, MutableRefObject } from 'react';
import { SuperTextAreaRef } from '@frontend/super-textarea';
import { contextFactory } from '@frontend/design-system';

type ContextState = {
  inputRef: MutableRefObject<SuperTextAreaRef>;
  editRef: MutableRefObject<SuperTextAreaRef>;
  focusInput: () => void;
  focusEditInput: () => void;
};

export const [ReviewReplyInputContext, useReviewReplyInput] = contextFactory<ContextState>(
  'useReviewReplyInput must be used within the ReviewReplyInputProvider'
);

export const ReviewReplyInputProvider = ({ children }: { children: React.ReactNode }) => {
  const inputRef = useRef() as MutableRefObject<SuperTextAreaRef>;
  const editRef = useRef() as MutableRefObject<SuperTextAreaRef>;

  const focusInput = () => {
    inputRef.current.focus();
  };

  const focusEditInput = () => {
    editRef.current.focus();
  };

  const value = {
    inputRef,
    editRef,
    focusInput,
    focusEditInput,
  };

  return <ReviewReplyInputContext.Provider value={value}>{children}</ReviewReplyInputContext.Provider>;
};
